import Reflux from 'reflux';
import { MediaLibraryOverviewActions, AppActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

const MediaLibraryOverviewStore = Reflux.createStore({
  listenables: [MediaLibraryOverviewActions],
  data: {
    entities: {},
    directoryId: 0,
    mode: 'list',
    loading: false,
    breadCrumbs: [],
    filter: {
      type: null,
      searchText: null
    },
    sort: {
      prop: 'created',
      direction: 'desc'
    },
    items: []
  },
  getInitialState() {
    return this.data;
  },
  changeDir(directoryId) {
    if (directoryId !== this.data.directoryId) {
      this.data = {
        ...this.data,
        directoryId
      };
      this.read(this.data.filter.type);
    }
  },
  changeSearchFilter(searchText) {
    const { filter } = this.data;
    this.data = {
      ...this.data,
      filter: {
        ...filter,
        searchText
      }
    };
    this.trigger(this.data);
  },
  gridMode() {
    this.data = {
      ...this.data,
      mode: 'grid'
    };
    this.trigger(this.data);
  },
  listMode() {
    this.data = {
      ...this.data,
      mode: 'list'
    };
    this.trigger(this.data);
  },
  read(type) {
    const { directoryId } = this.data;
    this.data = {
      ...this.data,
      filter: {
        ...this.data.filter,
        type
      },
      loading: true
    };
    this.trigger(this.data);
    return SteelCompass.request('file', 'listDirectory', { directoryId }).then(
      response => {
        MediaLibraryOverviewActions.readComplete(response);
      },
      error => {
        this.data = {
          ...this.data,
          loading: false
        };
        this.trigger(this.data);
        AppActions.genericError(error);
      }
    );
  },
  getEntities(files) {
    const items = [];
    const entities = {};
    files.forEach(item => {
      entities[item.id] = item;
      items.push(item.id);
    });
    return { items, entities };
  },
  readComplete(response) {
    const { files, breadcrumbs } = response;
    this.data = {
      ...this.data,
      loading: false,
      breadCrumbs: [{ id: 0, name: '' }, ...breadcrumbs.reverse()],
      ...this.getEntities(files)
    };
    this.trigger(this.data);
  }
});

export default MediaLibraryOverviewStore;



// WEBPACK FOOTER //
// ./src/js/stores/MediaLibraryOverview.js